import {Type} from "class-transformer";

export class FileLinkModel {
  FileName: string;
  Description: string;
  Mime: string;
  Path: string;
  FolderCode: string;
  @Type(() => Date)
  Date: Date;
  Base64: string;

  get DisplayName(){

    let s = this.FileName ?? this.Path ?? '';
    if(s){
      s = ' (' + s + ')';
    }
    return `${(this.Description ?? this.FileName ?? this.Path ?? '')}${s}`.trim()
  }

  constructor(init?: Partial<FileLinkModel>) {
    Object.assign(this, init);
  }
}
